import { HealthRecord } from "@syadem/kairos-citizen-js";
import { useCallback, useEffect, useState } from "react";
import { useKairosApi } from "./useKairosApi";

export function useHealthRecord(id: string): {
  isLoading: boolean;
  healthRecord?: HealthRecord;
  error?: Response | Error;
  refetch: () => void;
} {
  const api = useKairosApi();

  const [healthRecord, setHealthRecord] = useState<HealthRecord | undefined>(undefined);
  const [error, setError] = useState<Response | Error | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(true);

  const refetch = useCallback(() => {
    let isCancelled = false;
    (async () => {
      if (api) {
        try {
          const { healthRecord } = await api.healthRecordApi.showHealthRecord(id);
          if (!isCancelled) setHealthRecord(healthRecord);
        } catch (error) {
          if (error instanceof Response || error instanceof Error) {
            if (!isCancelled) setError(error);
          } else {
            throw error;
          }
        } finally {
          if (!isCancelled) setIsLoading(false);
        }
      }
    })();
    return () => {
      isCancelled = true;
    };
  }, [api, id]);

  useEffect(refetch, [refetch]);

  return { isLoading, healthRecord, error, refetch };
}
